import get from 'lodash/get';

import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { DISTRIBUTIONS } from '../names';

const getDistributionsForm = state => state.form[DISTRIBUTIONS];

export const doDistributionsFormExist = createSelector(
  getDistributionsForm, form => !!form
);

export const getDistributionsFormValues = createSelector(
  // Use get because form can be uninitialized yet
  getDistributionsForm, form => get(form, 'values')
);

export const hasDistributionsFormSyncErrors = createSelector(
  // Use get because form can be uninitialized yet
  getDistributionsForm, form => get(form, 'syncErrors')
);

const selector = formValueSelector(DISTRIBUTIONS);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getDistributionsType =
  makeFieldValueGetter('type');

export const getAlpha = makeFieldValueGetter('alpha');

export const getRightCutoff = makeFieldValueGetter('rightCutoff');
export const getLeftCutoff = makeFieldValueGetter('leftCutoff');

export const getBRightCutoff = makeFieldValueGetter('bRightCutoff');
export const getBLeftCutoff = makeFieldValueGetter('bLeftCutoff');

export const getLeftZScore = makeFieldValueGetter('leftZScore');

export const getRightZScore = makeFieldValueGetter('rightZScore');
